import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, Link } from "react-router-dom";
import "./DonationSchemes.css";
import "../DonationDetails/DonationDetails.css";
import axios from "axios";

function DonationSchemes() {
  const location = useLocation();
  const { email_id, waqf_id, dealName, transactionId ,parentPage} = location.state || {
    id: "Unknown ID",
    name: "Unknown Name",
  };
  const [isLoading, setIsLoading] = useState([true]);
  const [description, setDescription] = useState([true]);
  const [fundRaisingGoal, setFundRaisingGoal] = useState(null);
  const [grantsDistributed, setGrantsDistributed] = useState(null);
  const [contributionAmount, setContributionAmount] = useState(null);
  const [imageUrl, setImageUrl] = useState(null);

  sessionStorage.setItem("parentPage",parentPage);

  const [details, setDetails] = useState([""]);

  const [data, setData] = useState(null);

  console.log("ParentPage",parentPage);

  sessionStorage.setItem("transactionId", transactionId,"parentPage",parentPage);

  const email = email_id;

  useEffect(() => {
    axios
      .get(`/server/subscription/customer/waqfDetail/${waqf_id}/${email}`)
      .then((response) => {

        const data = response.data.data;
        setData(data);

        const fileDetails = [];

        const desc = data.Description;
        const fundRaisingGoal = data.Fundraising_Goal;
        const grantsDistributed = data.Grants_Distributed;
        const contributionAmount = data.Contribution_Amount;

        const imageUrl = data.Image_URL;

        setFundRaisingGoal(fundRaisingGoal);
        setGrantsDistributed(grantsDistributed);
        setContributionAmount(contributionAmount);
        setImageUrl(imageUrl);

        let doc = new DOMParser().parseFromString(desc, "text/html");
        let extractedText = doc.body.textContent || "";
        setDescription({ desc: extractedText });

        Object.keys(data).forEach((key) => {
          const match = key.match(/([A-Za-z]+)_(\d{4})/);

          if (match && Array.isArray(data[key]) && data[key].length > 0) {
            const month = match[1];
            const year = match[2];
            const formattedDate = `${month} ${year}`;

            data[key].forEach((file) => {
              fileDetails.push({
                date: formattedDate,
                fileName: file.file_Name,
                downloadUrl: file?.download_Url
                  ? `https://crm.zoho.com.au${file.download_Url}`
                  : `${file.preview_Url}?directDownload=true`,
              });
            });
          }
        });

        fileDetails.sort((a, b) => {
          const [monthA, yearA] = a.date.split(" ");
          const [monthB, yearB] = b.date.split(" ");
          const monthNames = [
            "January",
            "February",
            "March",
            "April",
            "May",
            "June",
            "July",
            "August",
            "September",
            "October",
            "November",
            "December",
          ];

          const monthIndexA = monthNames.indexOf(monthA);
          const monthIndexB = monthNames.indexOf(monthB);

          if (yearA === yearB) {
            return monthIndexB - monthIndexA;
          } else {
            return yearB - yearA;
          }
        });

        setDetails(fileDetails);
      })
      .catch((error) => {
        console.error("Error fetching subscription data:", error);
      })
      .finally(() => setIsLoading(false));
  }, [waqf_id, location.key]);

  useEffect(() => {
    // console.log("Updated details:", details);
  }, [details]);

  const breadcrumbs = parentPage === "dashboard" ? (
    <>
      <li className="inline-flex items-center">
        <Link
          to="/dashboard"
          className="ms-1 text-[14px] text-gray-400 hover:text-[#0E5C57] md:ms-2"
        >
          Dashboard
        </Link>
      </li>
    </>
  ) : (
    <>
       <li class="inline-flex items-center">
            <Link
              to="/subscription"
              className="ms-1 text-[14px] text-gray-400 hover:text-[#0E5C57] md:ms-2 dark:text-gray-400 dark:hover:text-white"
            >
              Donation
            </Link>
          </li>
          <li>
            <div class="flex items-center">
              <svg
                class="rtl:rotate-180 w-2.5 h-2.5 text-gray-400 mx-1 text-[14px]"
                aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 6 10"
              >
                <path
                  stroke="currentColor"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="m1 9 4-4-4-4"
                />
              </svg>
              <Link
                to="/donationDetails"
                state={{ transactionId }}
                className="ms-1 text-[14px] text-gray-400 hover:text-[#0E5C57] md:ms-2 dark:text-gray-400"
              >
                Donation {transactionId}
              </Link>
            </div>
          </li>
    </>
  );
  

  return (
    <div class="bg-[#F7F7F7] -m-[23px] p-[30px] pl-[45px] pr-[45px] min-h-screen  flex flex-col no-scrollbar max-sm:h-[auto] overflow-auto">
      {isLoading && (
        <div className="absolute inset-0 flex fixed h-150vh justify-center items-center bg-white bg-opacity-75 z-50">
          <div className="animate-spin w-12 h-12 border-[4px] rounded-full border-l-[#095856] border-black"></div>
        </div>
      )}
      <nav class="flex" aria-label="Breadcrumb">
        <ol class="inline-flex items-center space-x-1 md:space-x-2 rtl:space-x-reverse">
          {breadcrumbs}
          <li aria-current="page" className="block max-sm:hidden">
            <div class="flex items-center">
              <svg
                class="rtl:rotate-180 w-2.5 h-2.5 text-gray-400 mx-1"
                aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 6 10"
              >
                <path
                  stroke="currentColor"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="m1 9 4-4-4-4"
                />
              </svg>
              <span class="ms-1 text-[14px] text-gray-400 md:ms-2 dark:text-gray-400">
                {dealName}
              </span>
            </div>
          </li>
        </ol>
      </nav>

      <div class="flex flex-col max-sm:block">
        <h5 class="font-Jost text-2xl font-medium leading-[36.4px] mb-2 mt-2">
          {dealName}
        </h5>
      </div>

      <div class="bordercolor flex flex-wrap mb-2 mt-2 w-[100%] h-112px  max-sm:block">
        <div class=" p-2">
          <div class="donationCard">
            <div class="p-4 donationCardContent">
              <h6 class="donationCardPay text-[24px] max-sm:text-[14px]">
                $
                {contributionAmount
                  ? contributionAmount.toLocaleString()
                  : "0.00"}
              </h6>
              <p class="donationCardvalue font-[600]">Contribution</p>
            </div>
          </div>
        </div>
        <div className="p-2">
          <div className="donationCard">
            <div className="p-4 donationCardContent">
              <h6 className="donationCardPay text-[24px] max-sm:text-[14px]">
                $
                {data?.Total_Deals_Amount
                  ? data.Total_Deals_Amount.toLocaleString()
                  : "0.00"}
              </h6>
              <p className="donationCardvalue font-[600]">Fund Raised</p>
            </div>
          </div>
        </div>
        <div class="p-2">
          <div class="bg-white shadow-lg rounded-lg donationCard">
            <div class="p-4 donationCardContent">
              <h6 class="text-lg font-bold donationCardPay">
                {" "}
                ${fundRaisingGoal ? fundRaisingGoal.toLocaleString() : "0.00"}
              </h6>
              <p class="donationCardvalue font-[600]">Fundraising Goal</p>
            </div>
          </div>
        </div>
        <div class="p-2">
          <div class="bg-white shadow-lg rounded-lg donationCard">
            <div class="p-4 donationCardContent">
              <h6 class="text-lg font-bold donationCardPay">
                $
                {grantsDistributed
                  ? grantsDistributed.toLocaleString()
                  : "0.00"}
              </h6>
              <p class="donationCardvalue font-[600]">Grants Distributed YTD</p>
            </div>
          </div>
        </div>
      </div>

      <div class="placeholder p-6 mb-6 mt-2 h-[300px] w-[auto] max-sm:h-[auto]">
        <div className="grid grid-cols-2 gap-60 max-sm:grid-cols-1 max-sm:gap-8">
          <div className="flex items-center justify-center bg-gray-200 rounded-lg w-[502px] h-[150px] max-sm:w-[auto] max-sm:justify-items-start hidden max-sm:flex">
            {/* <p className="text-black-500">PLACEHOLDER</p> */}
            <img
              className="w-[auto] rounded-xl"
              src={imageUrl ? imageUrl : "https://cdn.sanity.io/images/w2w52q2y/development/b4bca18e43c93679ea4698df42359ec9ae5ac7af-1456x816.jpg"}
              alt="ImagePlaceHolder"
              srcset=""
            />
          </div>

          <div>
            <p className="text-gray-600 mb-4 text-[14px]">{description.desc}</p>
          </div>
          <div className="flex items-center justify-center bg-gray-200 rounded-lg w-[502px] h-[255px] max-sm:w-[auto] max-sm:hidden">
            {/* <p className="text-black-500">PLACEHOLDER</p> */}
            <img
              className="w-[auto] rounded-xl"
              src={imageUrl ? imageUrl : "https://cdn.sanity.io/images/w2w52q2y/development/b4bca18e43c93679ea4698df42359ec9ae5ac7af-1456x816.jpg"}
              alt="ImagePlaceHolder"
              srcset=""
            />
          </div>
        </div>
      </div>

      {/* <hr className="text-[#D1D1D1] mt-6" /> */}

      <div className="flex-1  max-h-[calc(100vh-150px)] scrollbar mt-6  w-[auto] max-sm:max-h-[100%] ">
        <h6 className="text-[28px] font-medium">Reports</h6>
        <div className="flex flex-col gap-[18px] ">
          {details.length > 0 ? (
            details.map((item) => (
              <div className="flex flex-row justify-center items-center gap-[40px] max-sm:flex-col">
                <div className="bg-white rounded-[8px] border-[1px] border-[#0000001A] h-[121px] w-[100%] p-[40px] pr-[32px] pl-[25px] mb-[0] shadow-none max-sm:h-[180px] max-sm:mb-[20px] max-sm:p-[20px]">
                  <div className="flex flex-row gap-[50px] items-center max-sm:flex-col max-sm:gap-[5px] max-sm:items-start">
                    <div className="flex items-center w-[300px] h-[24px]  max-sm:w-[auto]">
                      <p className="text-black font-Jost text-[18px] font-normal max-sm:text-[14px]">
                        {item.date}
                      </p>
                    </div>

                    <div className="flex items-center w-[400px] h-[49px] max-sm:w-[auto]">
                      <p className="font-Jost  font-medium text-[#0E5C57] text-[18px] cursor-pointer line-clamp-1-5 max-sm:text-sm">
                        {item.fileName}
                      </p>
                    </div>

                    <div className="w-[250px] h-[24px] max-sm:w-[100%]">
                      <button
                        className="downloadBtn w-[164px] max-sm:w-[100%] cursor-pointer"
                        onClick={() => window.open(item.downloadUrl, "_blank")}
                      >
                        Download
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <p className="text-center text-gray-500 mt-20 mr-80 max-sm:mr-5 max-sm:mt-5">
              No Reports are available for this Waqf just yet.
            </p>
          )}
        </div>
      </div>
    </div>
  );
}

export default DonationSchemes;
